import {get} from 'lodash'

type Props = {
  config: object
}

export const TWSE = ({config}: Props) => {
  return <>{get(config, 'text', '')}</>
}
